import React, { Fragment } from 'react'
import { FieldArray, useFormikContext } from 'formik'
import { Column, Row } from '@/components/layout/layout'
import classNames from 'classnames'
import { IPakageForm } from '../../package-type'
import Input from '@/components/input/input'
import { getBEMCls } from '@/utils/classname'
import { useCheckForm } from '@/utils/form'

const BarcodeInput = () => {
    const cls = (...args: string[]) => getBEMCls('edit-package', ...args)
    const { values, handleBlur, handleChange } = useFormikContext<IPakageForm>()
    const { checkError, getErrorStr } = useCheckForm<IPakageForm>()

    return (
        <FieldArray name="barcodes">
            {barcodesArrayHelper => (
                <Fragment>
                    {values.barcodes?.map((val, index, arr) => {
                        return (
                            <Column key={index}>
                                <Row data-align-items-center data-padding-h-24>
                                    <span
                                        style={{
                                            width: arr.length > 1 ? '74px' : '56px',
                                        }}
                                        className={classNames(cls('form-item', 'title'), cls('form-item', 'require'))}
                                    >
                                        商品条码{arr.length > 1 && index + 1}
                                    </span>
                                    <Row data-align-items-center data-expaned data-position-relative>
                                        <Input
                                            reg={/^\d{0,14}$/}
                                            error={checkError(`barcodes[${index}]`)}
                                            name={`barcodes[${index}]`}
                                            value={values.barcodes[index]}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="请输入"
                                            inputsuffix={() => {
                                                return (
                                                    <Row data-algin-items-center>
                                                        <span data-font-size-14 data-color-000>
                                                            {values.barcodes[index].length}
                                                            /14
                                                        </span>
                                                        {index !== 0 && (
                                                            <i
                                                                onClick={() => {
                                                                    barcodesArrayHelper.remove(index)
                                                                }}
                                                                style={{ color: '#f00' }}
                                                                data-margin-left-4
                                                                className="iconfont icon6yichu-20"
                                                            ></i>
                                                        )}
                                                    </Row>
                                                )
                                            }}
                                        ></Input>
                                    </Row>
                                </Row>
                                <span
                                    style={{
                                        marginLeft: arr.length > 1 ? '114px' : '96px',
                                    }}
                                    data-padding-top-8
                                    className={classNames(cls('form-item', 'error'))}
                                >
                                    {getErrorStr(`barcodes[${index}]`)}
                                </span>
                            </Column>
                        )
                    })}

                    <Row data-align-items-center data-height-50 data-padding-h-24>
                        <span
                            data-color-999
                            data-font-weight-400
                            className={classNames(cls('form-item', 'title'))}
                        ></span>
                        <Row
                            onClick={() => {
                                barcodesArrayHelper.push('')
                            }}
                            data-align-items-center
                            data-expaned
                            data-position-relative
                        >
                            <span className="text-btn-blue">+新增条码</span>
                        </Row>
                    </Row>
                </Fragment>
            )}
        </FieldArray>
    )
}

export default BarcodeInput
